import CardLogin from 'app/components/Layouts/CardLogin';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import useOTP from './useOTP';
import { descText, infoText, btnBox, resendLink } from './OTP.sx';
import OTPInput from 'react-otp-input';
import styles from './otp.module.css';
import { errorText, warningBox } from 'app/components/LoginForm/LoginForm.sx';
import WarningIcon from 'app/components/Icons/WarningIcon';
import BackButton from 'app/components/BackButton';
import CountdownTimer from 'app/components/CountdownTimer';
import coinsStackedIconSelect from "app/components/Icons/CoinsStackedIconSelect";

interface Props {
    setModalOtp?: (newOtp:string) => void;
}

const OTP = (props:Props) => {

    const {setModalOtp} = props

    const { t, otp, data, dataOtp, handleSubmitForm, handleChange, resentOtp } = useOTP({setModalOtp});

  return (
      <Box>
        <OTPInput
            value={otp}
            onChange={handleChange}
            numInputs={6}
            renderInput={(inputProps) => <input {...inputProps} className={styles.otpInput} />}
            shouldAutoFocus={true}
        />
        <CountdownTimer text={'Qalan vaxt'} repeat={resentOtp} otp={true} />
      </Box>
  );
};

export default OTP;
